import PropTypes from 'prop-types';
import { useTooltipInPortal, defaultStyles } from '@visx/tooltip';
import ChartLegend from '../../molecules/ChartLegend';

const styles = {
  ...defaultStyles,
  minWidth: 60,
  backgroundColor: '#3c4257f0',
  color: 'white',
  borderRadius: '0.75rem',
  padding: '1rem',
};

function BarStackChartTooltip({
  top = 0,
  left = 0,
  keys = [],
  keyNameMap = {},
  data = {},
  titleAccessor = () => {},
  titleFormatter = () => {},
  colorScale = () => {},
  valueFormatter = () => {},
  highlightedKey = null,
}) {
  const { TooltipInPortal } = useTooltipInPortal({ scroll: true });
  const barData = data.bar?.data || {};
  const visibleKeys = keys.filter((key) => Number(barData[key]) > 0);
  const valueMap = visibleKeys.reduce((map, key) => {
    map[key] = { current: barData[key] };
    return map;
  }, {});
  const highlightedLabel = highlightedKey ? keyNameMap?.[highlightedKey] || highlightedKey : null;

  return (
    <TooltipInPortal className="BarStackChart-tooltip" top={top} left={left} style={styles}>
      <div className="BarStackChart-tooltipHeader">
        <div>{titleFormatter(titleAccessor(data.bar.data))}</div>
        <div>{valueFormatter(keys.reduce((total, key) => total + data.bar.data[key], 0))}</div>
      </div>
      <ChartLegend
        keys={visibleKeys}
        keyNameMap={keyNameMap}
        valueMap={valueMap}
        colorScale={colorScale}
        valueFormatter={valueFormatter}
        highlightedKey={highlightedKey}
      />
      {highlightedLabel ? (
        <div className="BarStackChart-tooltipHint">Click to filter by {highlightedLabel}</div>
      ) : null}
    </TooltipInPortal>
  );
}

BarStackChartTooltip.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  keys: PropTypes.array,
  keyNameMap: PropTypes.object,
  data: PropTypes.object,
  titleAccessor: PropTypes.func,
  titleFormatter: PropTypes.func,
  colorScale: PropTypes.func,
  valueFormatter: PropTypes.func,
  highlightedKey: PropTypes.string,
};

export default BarStackChartTooltip;
